import { render, staticRenderFns } from "./SignIn4.vue?vue&type=template&id=0f5ecaf9&scoped=true&lang=pug&"
import script from "./SignIn4.vue?vue&type=script&lang=ts&"
export * from "./SignIn4.vue?vue&type=script&lang=ts&"
import style0 from "./SignIn4.vue?vue&type=style&index=0&id=0f5ecaf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ecaf9",
  null
  
)

export default component.exports